import { z } from 'zod'
import { AppKind, type BaseApp } from '../../models/App'

export const BaseAppDTO = z.object({
  id: z.number().optional(),
  type: z.nativeEnum(AppKind).optional(),
  name: z.string()
})

export type BaseAppDTO = z.infer<typeof BaseAppDTO>

export function mapBaseAppToDTO (model: BaseApp): BaseAppDTO {
  return {
    id: model.id,
    type: model.kind,
    name: model.name
  }
}

export function mapDTOToBaseApp (dto: BaseAppDTO): BaseApp {
  return {
    id: dto.id,
    kind: dto.type,
    name: dto.name ?? ''
  }
}
